import { Layout } from "components/Layout/Layout";
import { Location } from "history";
import { AccountCardState } from "pages/TemporaryLockUnlockCard/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { TemporaryLockUnlockCard } from "./TemporaryLockUnlockCard";

export const TemporarilyLockCardPage = () => {
  const { state } = useLocation() as Location<AccountCardState>;
  const routerNavigate = useNavigate();
  if (!state || !state.account.credit_card || !state.product) {
    routerNavigate("/manage-accounts", {
      replace: true,
    });
    return null;
  }

  const props = {
    token: state.account.credit_card.token,
    cardEndsWith: state.account.credit_card.linked_card_last4,
    cardName: state.product.name,
    productCode: state.product.code,
  };

  return (
    <Layout>
      <Layout.Header>Temporarily lock card</Layout.Header>
      <Layout.Main>
        <TemporaryLockUnlockCard {...props} />
      </Layout.Main>
    </Layout>
  );
};
